<template>
  <v-toolbar app absolute dense color="accent" dark @click="'test'">
    <v-toolbar-side-icon @click.native="expandLeftMenu()"></v-toolbar-side-icon>

    <v-toolbar-title></v-toolbar-title>
    <v-toolbar-items>
      <v-btn dark flat to="/" active-class>ĎURIŠ Nábytok</v-btn>
      <v-btn dark flat @click="oldPageRedirect" active-class class="hidden-sm-and-down">
        <v-icon class="mr-2">public</v-icon>
        <span class="caption">stará web stránka</span>
      </v-btn>
      <v-divider v-if="$can('read', 'navigation')" class="hidden-sm-and-down" vertical inset></v-divider>
      <v-btn
        v-if="$can('read', 'navigation')"
        color="white"
        flat
        to="/cutting"
        active-class
        class="hidden-sm-and-down"
      >
        <v-icon small class="pr-2">perm_data_setting</v-icon>Rezanie materiálu
      </v-btn>
      <!-- <v-divider vertical inset></v-divider>
      <v-btn color="white" flat>Kontakt</v-btn>
      <v-divider vertical inset></v-divider>-->
    </v-toolbar-items>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <v-menu offset-y left v-if="isAuthenticated">
        <v-btn slot="activator" dark flat>
          <v-icon dark left>perm_identity</v-icon>
          <span class="hidden-sm-and-down">{{username}}</span>
        </v-btn>
        <v-list>
          <template v-for="(item, i) in items">
            <v-list-tile @click="item.action" :key="i">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>

      <v-btn flat v-else to="/auth">Prihlásiť sa</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import * as types from "@/store/types";
export default {
  name: "TopNavigation",
  data() {
    return {
      items: [
        {
          icon: "accessibility",
          text: "Môj účet",
          action: this.personalAccount
        },
        {
          icon: "assignment",
          text: "Moje objednávky",
          action: this.personalOrders
        },
        {
          icon: "exit_to_app",
          text: "Odhlásiť",
          action: this.logout
        }
      ]
    };
  },
  computed: {
    username() {
      return this.$store.getters.username;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    expandLeftMenu: function() {
      this.$store.commit(types.EXPAND_LEFT_NAVIGATION, true);
    },
    test: function() {
      this.$store.commit(types.SHOW_GLOBAL_ALERT, {
        value: true,
        message: "testing",
        color: "warning"
      });
    },
    personalAccount() {
      this.$router.push({
        path: "/account"
      });
    },
    personalOrders() {
      this.$router.push({
        path: "/orders"
      });
    },
    logout: function() {
      this.$store
        .dispatch(types.AUTH_LOGOUT)
        .then(() => {
          this.$router.push({
            path: "/"
          });
          console.log("logout");
        })
        .catch(e => {
          console.error(e);
        });
    },
    oldPageRedirect() {
      window.open("http://new.duris.info", "_blank");
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>